<div class="container-fluid mt-5">
    <div class="row">
        <div
            class="col-sm-6"
            [ngClass]="
                this.updatedtheme === 'dark' ? 'headlinetextD' : 'headlinetextL'
            "
        >
            <h3 class="m-0 pl-2">Reports</h3>
        </div>
    </div>
    <br />
    <div class="row">
        <div
            class="col-4"
            [ngClass]="
                this.updatedtheme === 'dark' ? 'reportsclassD' : 'reportsclassL'
            "
            *ngFor="let report of reports"
        >
            <h4>{{ report.heading }}</h4>
            <p>{{ report.pera }}</p>
            <button [routerLink]="report.route">{{ report.button }}</button>
        </div>
    </div>
</div>
